module.exports = __webpack_public_path__ + "static/media/Mere-Exposure Effect, Familiarity Principle.23a60aea.jpg";